import {
  takeLatest, put, call, select,
} from 'redux-saga/effects';
import actionTypes from 'store/table/actionTypes1';
import api from 'store/api';
import { toast } from 'react-toastify';
import { URL } from '../../../constants/url';
import {
  getBb, getGgps, getStake, getTs,
} from '../selectors';
import { setFirstPairCardTableFold } from '../actions';

export function* setFirstPair(payload) {
  const ts = yield select(getTs);
  const stake = yield select(getStake);
  const bb = yield select(getBb);
  const ggps = yield select(getGgps);

  try {
    const res = yield call(api, {
      method: 'post',
      url: sessionStorage.getItem('isPlo5') === 'true' ? URL.PLO5FIRST_PAIR : URL.FIRST_PAIR,
      data: {
        ts,
        // eslint-disable-next-line no-nested-ternary
        bb: ts !== 'mtt' ? (stake.includes('0') ? 'rfivssqz' : bb) : `${bb}potopen`,
        stake,
        easy: payload.easy,
        game: payload.gameTable,
        smart_range: payload.smartRange,
        gg: ggps === 'gg',
      },
    });

    const { data } = res;
    yield put(setFirstPairCardTableFold.success({
      cells: data?.cells,
      purple: data?.purple,
    }));
  } catch (e) {
    yield call(toast.error, e.message);
    yield put(setFirstPairCardTableFold.error({
      e,
    }));
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.SET_FIRST_PAIR, setFirstPair);
}
